import { Injectable } from "@angular/core";
import { ServiceConfig } from "app/_services/service-config";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class UserTimeReportService {
  private host = ServiceConfig.host;
  private BASE_URL = this.host + "/api/user-time-report/";
  private httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  private httpParams = new HttpParams().set(
    "token",
    JSON.parse(localStorage.getItem("currentSmmData")).token
  );

  constructor(private httpClient: HttpClient) {}

  async getLists(optionsFilter: any): Promise<any> {
    return await this.httpClient
      .post(this.BASE_URL + "list", optionsFilter, {
        params: this.httpParams,
        headers: this.httpHeaders,
      })
      .toPromise();
  }
  async getExportLists(optionsFilter: any): Promise<any> {
    return await this.httpClient
      .post(this.BASE_URL + "export-list", optionsFilter, {
        params: this.httpParams,
        headers: this.httpHeaders,
      })
      .toPromise();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/user-time-report.service.ts